/***************************************************************************************
 * @module       Index 
 * @name         Index
 * @description  Application entry point that sets up React, Redux store and global providers
 * @version      1.0.0
 * @license      Licensed under the MIT License
 * @createdon    May 2025
 * @since        1.0
 * @deploy      Rebuild marker — staging-build-002 (PDF watchdog deploy, 2026-06-11)
 ***************************************************************************************/

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import {store} from './reduxtoolbox/stores/techus-reduxStore';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/index.css'
import './assets/common.css'
import './assets/Images/logos/favicon.png'
import CONFIG from './config/config';
// userback configuration setup
import { UserbackProvider } from '@userback/react';

// identify your logged-in users (optional)
const user_data = {
  id: localStorage.getItem("uuid") || undefined
};

window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('Loading chunk')) {
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
// Skip Userback wrapper when no real token is configured (e.g. local dev).
// Userback throws on render when given an invalid token, which would replace
// the whole app with an error page.
const hasValidUserbackToken =
  CONFIG.USERBACK_TOKEN &&
  CONFIG.USERBACK_TOKEN !== 'unused_locally' &&
  !CONFIG.USERBACK_TOKEN.startsWith('local_dev');

const appTree = hasValidUserbackToken ? (
  <UserbackProvider token={CONFIG.USERBACK_TOKEN} options={{ user_data }}>
    <App />
  </UserbackProvider>
) : (
  <App />
);

root.render(
  <Provider store={store}>
    {appTree}
  </Provider>,
);



